<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{ $t('imageRecordUpload') }}
                    </div>
                    <div class="modal-body">
                        <label>{{ $t('folderName') }}</label>
                        <input class="form-control" v-model="folderName">
                    </div>
                    <div class="modal-footer">
                        <button v-bind:class="[buttonLoading, syncLoading]" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ $t('uploading') }}
                        </button>
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="uploadFiles" >
                            {{ $t('upload') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import ImageApi from '../../../api/server/image';

export default {
    name: "UploadXlsxDialog",
    notifications: {
        showSuccess: { 
            title: 'Getan!',
            message: 'Files were successfully uploaded.',
            type: 'success'
        },
        showError: { 
            title: 'Error!',
            message: 'Error while uploading files, OBJECTID not found.',
            type: 'error'
        }
    },
    methods: {
        close() {
            this.$parent.showUploadImageRecordsModal = false;
        },
        async uploadFiles() {
            this.syncLoading = "";
            try {
                await ImageApi.imageFolderUpload(this.$parent.data.id, this.folderName);
                this.close();
                this.showSuccess();
                this.$emit("reload");
            } catch {
            } finally {
                this.folderName = "";
                this.buttonLoading = "hidden";
            };
        },
    },
    data() {
        return {
            buttonLoading: 'btn btn-primary',
            syncLoading: "hidden",
            folderName: "",
        };
    },
};
</script>